import type { WidgetState } from './types';

export const initialState: WidgetState = {
    isKlarnaButtonAvailable: null,
    isKlarnaButtonDisplayed: false,
    isPaypalButtonDisplayed: false,
    isApplePayButtonDisplayed: null,
    isAnyButtonReady: false,
    activeBasketSummary: null,
};
